import isEmpty from "lodash-es/isEmpty";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { ThemeColorProperties } from "@/types/theme";
import { defaultTheme } from "@/theme/theme";
import { settingsFromApiApplied } from "@/store/settings/settingsFlowActions";

const initialState = {
  props: defaultTheme,
};

const themeColorSlice = createSlice({
  name: "themeColor",
  initialState: initialState,
  reducers: {
    updateThemeColor: (state, action: PayloadAction<ThemeColorProperties>) => {
      const { payload } = action;
      const keys: (keyof ThemeColorProperties)[] = [
        "backgroundColor",
        "primaryColor",
        "textColor",
        "secondaryColor",
        "tertiaryColor",
        "quaternaryColor",
        "neutralColor",
        "borderColor",
      ];
      for (const key of keys) {
        if (!isEmpty(payload[key])) {
          state.props[key] = payload[key];
        }
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(settingsFromApiApplied, (state, action) => {
      const payload = action.payload.theme;
      if (payload == null) {
        return;
      }
      const keys: (keyof ThemeColorProperties)[] = [
        "backgroundColor",
        "primaryColor",
        "textColor",
        "secondaryColor",
        "tertiaryColor",
        "quaternaryColor",
        "neutralColor",
        "borderColor",
      ];
      for (const key of keys) {
        if (!isEmpty(payload[key])) {
          state.props[key] = payload[key];
        }
      }
    });
  },
});

export const { updateThemeColor } = themeColorSlice.actions;
export default themeColorSlice.reducer;
